import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
    PULL_UUID_REQUEST,
    PULL_UUID_SUCCESS,
    PULL_UUID_FAILURE,
    PULL_UUID_LOADER,
} = documentationActions;

function* pullUuid(action: any): SagaReturnType<any> {
  try {
    yield put({ type: PULL_UUID_LOADER });
    const response = yield call(
      templateService.pullUuid,
      action.payload,
      action.params,
    );
    if (response?.status === 200) {
      yield put({ type: PULL_UUID_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: PULL_UUID_FAILURE, payload: error });
  }
}

function* pullUuidSaga() {
  yield takeEvery(PULL_UUID_REQUEST, pullUuid);
}

export default pullUuidSaga;
